export interface CalendarDay {
  date: Date;
  dayNumber: number;
  isToday: boolean;
  isInCurrentMonth: boolean;
  isInRange: boolean; // Is within the selected study date range
  isMarkedOff: boolean; // Is marked as unavailable
  isCatchUpDay: boolean;
  totalMinutes: number; // Total minutes allocated to tasks
  tasks: CalendarTask[];
}

export interface CalendarTask {
  id: string;
  name: string;
  type: string;
  completed: boolean;
  color: string;
  duration: number; // In minutes
  isRecurringInstance?: boolean; // Indicates if this is a recurring task instance
}

export interface CalendarWeek {
  days: CalendarDay[];
  weekNumber: number;
}

export interface CalendarMonth {
  year: number;
  month: number; // 0-based (0 = January)
  weeks: CalendarWeek[];
}

export enum CalendarViewType {
  MONTH = 'month',
  WEEK = 'week',
  DAY = 'day'
} 